var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 27.155,
    viewBox: "0 0 16 27.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.423,361.155,332,358.732l8.488-11.155L332,336.422,334.423,334,348,347.577Z",
    transform: "translate(-332 -334)",
    fill: "#0b3558"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronRight);
export default __webpack_public_path__ + "static/media/ic_chevron_right.d2f17564fc0c427c6d8c6c9caaf276b3.svg";
export { ForwardRef as ReactComponent };